import { useState, useEffect } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const previewApiService = async courseId =>
  new JsonApiService("course_previews", {
    baseUrl: `${visionURL}/admin_console/api/content/courses/${courseId}`,
    credentials: "include"
  });

export const useCoursePreview = currentCourseId => {
  const [isLoading, setIsLoading] = useState(false);
  const [coursePreview, setCoursePreview] = useState(null);

  useEffect(() => {
    const fetchCoursePreview = async () => {
      if (currentCourseId) {
        setIsLoading(true);
        const service = await previewApiService(currentCourseId);
        const response = await service.all().then(response => response.json());
        setIsLoading(false);
        setCoursePreview(dataFormatter.deserialize(response));
      }
    };

    fetchCoursePreview();
  }, [currentCourseId]);

  return {
    coursePreview,
    isLoading
  };
};
